import React from 'react'; 

function ObjectConfigTable({ configBlob = [] }) {
    function keyVals(configList) {
        const displayList = [];
        for (const config of configList) {
            const result = [];
            for (const blobAttribute in config.runConfig) {
                result.push({
                    key: blobAttribute,
                    value: JSON.stringify(config.runConfig[blobAttribute]),
                });
            }
            displayList.push({ data: result, header: config.dataTypeLabel });
        }
        return displayList;
    }

    const display = keyVals(configBlob);

    return (
        <div>
            {display.map((section, sectionIndex) => (
                <div key={`${section.header}-${sectionIndex}`}>
                    <b>{section.header} Defaults</b>
                    <table>
                        <colgroup>  
                            <col style={{ width: '25%' }} />
                            <col style={{ width: '75%' }} />
                        </colgroup>
                        <thead>
                            <tr>
                                <th>Key</th>
                                <th>Value</th>
                            </tr>
                        </thead>
                        <tbody>
                            {section.data.map((entry) => {
                                return (
                                    <tr key={`${section.header}-${entry.key}`}>
                                        <td>{entry.key}</td>
                                        <td>{entry.value}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            ))}
        </div>
    );
}

export default ObjectConfigTable;
